'use strict';
import angular from 'angular';
import tiktokDeviceHtmlUrl from './views/tiktokDeviceList.html';
import tiktokChildDataHtmlUrl from './views/tiktokRecursiveTemplate.html';
let app = angular.module('app.tiktokDevice.component', []);

app.component('tiktokDeviceTargeting', {
    bindings: {
        showActions: '<',
        showActionsForOsVersion: '<',
        selectedTiktokDeviceTargeting: '=',
        clusterId: '=',
        isFormEdit: '=',
        clientId: '='
    },
    templateUrl: tiktokDeviceHtmlUrl,
    // The controller that handles our component logic
    controller: function(ProductService) {
        let self = this;
        self.operatingSystems = ['ANDROID', 'IOS'];
        self.selectedOperatingSystem = '';
        self.selectedOperatingSystemVersion = '';
        self.osVersionList = [];
        self.devicesList = [];
        self.carriersList = [];
        self.ispList = [];
        self.tiktokChildDataHtmlUrl = tiktokChildDataHtmlUrl;
        self.errorFetchingCarriers = false;
        self.errorFetchingIsp = false;
        self.errorFetchingOsVersions = false;

        self.IsChildObjectVisible = function(parent, child){
            let searchKey = $scope.search;
            let returnVal = true;
            if (undefined != searchKey && null != searchKey && searchKey.length > 0) {
                returnVal = ((child.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1) ||
                    (parent.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1));
            }
            return returnVal;
        }

        self.handleSelectSubChild = function (item, child, selectedTiktokDevice, indx, type) {
            if (type == "Devices") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedTiktokDevice.devices.indexOf(child);
                    selIndex = _.findIndex(selectedTiktokDevice.devices, {id: child.id});
                    if (selIndex >= 0) {
                        selectedTiktokDevice.devices.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedTiktokDevice.devices.push(child);
                }
            } else if (type == "Carriers") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedTiktokDevice.carriers.indexOf(child);
                    selIndex = _.findIndex(selectedTiktokDevice.carriers, {id: child.id});
                    if (selIndex >= 0) {
                        selectedTiktokDevice.carriers.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedTiktokDevice.carriers.push(child);
                }
            } else if (type == "Isp") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedTiktokDevice.isp.indexOf(child);
                    selIndex = _.findIndex(selectedTiktokDevice.isp, {id: child.id});
                    if (selIndex >= 0) {
                        selectedTiktokDevice.isp.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedTiktokDevice.isp.push(child);
                }
            }
        }

        self.toggleOperatingSystemsList = function () {
            self.showActions = !self.showActions;
        };

            self.toggleOperatingVersionsList = function () {
            self.showActionsForOsVersion = !self.showActionsForOsVersion
        };

        self.handleSelectOperatingSystem = function(operatingSystem) {
            // If the selected OS is already chosen, deselect it (none selected)
            if (self.selectedOperatingSystem === operatingSystem) {
                self.selectedOperatingSystem = '';
                self.selectedTiktokDeviceTargeting[0].operatingSystem = '';
            } else {
                // Set the new OS selection and clear others
                self.selectedOperatingSystem = operatingSystem;
                self.selectedTiktokDeviceTargeting[0].operatingSystem = self.selectedOperatingSystem;
            }

            // If an OS is selected, fetch its versions
            if (self.selectedOperatingSystem !== '') {
                self.getOperatingSystemVersions();
            }
        }

        self.handleSelectOperatingSystemVersion = function(operatingSystemVersion) {
            // If the selected version is already chosen, deselect it (none selected)
            if (self.selectedOperatingSystemVersion === operatingSystemVersion.name) {
                self.selectedOperatingSystemVersion = '';
                self.selectedTiktokDeviceTargeting[0].operatingSystemVersion = {};
            } else {
                // Set the new OS version and clear others
                self.selectedOperatingSystemVersion = operatingSystemVersion.name;
                self.selectedTiktokDeviceTargeting[0].operatingSystemVersion = operatingSystemVersion;
            }
        }
        self.handleSelectDevices = function (devices, selectedTiktokDeviceTargeting) {
            if (!devices.isChecked) {
                devices.status = '';
                devices.isChecked = false;
                let selIndex = selectedTiktokDeviceTargeting.intrests.indexOf(devices);
                if (selIndex >= 0) {
                    selectedTiktokDeviceTargeting.devices.splice(selIndex, 1);
                } else {
                    if (selectedTiktokDeviceTargeting.devices && selectedTiktokDeviceTargeting.devices.length > 0) {
                        if (_.find(selectedTiktokDeviceTargeting.devicesList, { id: devices.id })) {
                            let index = _.findIndex(selectedTiktokDeviceTargeting.devicesList, { id: devices.id });
                            selectedTiktokDeviceTargeting.devices.splice(index, 1);
                        }
                    }
                }
            } else {
                devices.status = 'selected';
                devices.isChecked = true;
                selectedTiktokDeviceTargeting.devices.push(devices);
            }
        }

        self.getDevices = function() {
            ProductService.getDevicesContentForTiktok({ clientId:self.clientId,clusterId:self.clusterId, operatingSystem:self.selectedOperatingSystem}).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function (content) {
                        let devices = {};
                        devices.id = content.id;
                        devices.name = content.name;
                        devices.level = content.level;
                        devices.status = "";
                        devices.isChecked = false;
                        devices.parentName = content.parentName;
                        devices.childData = content.childData;
                        devices.type = content.type;
                        self.devicesList.push(devices);
                    });
                    _.each(self.selectedTiktokDeviceTargeting,function(item){
                        item.devicesList = angular.copy(self.devicesList);
                    })
                    processDevicesData();
                }
            }, function (error) { });
        }
        let processDevicesData = function () {
            _.each(self.selectedTiktokDeviceTargeting, function (data) {
                _.each(data.devices, function (item) {
                    _.each(data.devicesList, function (e) {
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubDevices(e.childData,data.devices);
                        }
                    })
                })
            })
        }

        self.removeDevices = function (item, selectedDevices, devicesList) {
            let selIndex = selectedDevices.indexOf(item);
            if (selIndex >= 0) {
                selectedDevices.splice(selIndex, 1);
                self.clearSelectedData(item,devicesList);
            }
        }

        self.clearSelectedData = function(item,totalList){
            _.each(totalList,function(e){
                if (e.id == item.id) {
                    e.status = '';
                    e.isChecked = false;
                }
                if (e.childData && e.childData.length > 0) {
                    self.clearSelectedData(item,e.childData)
                }
            })
        }

        let processSubDevices = function(childData,selectedDevices){
            _.each(selectedDevices,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubDevices(e.childData,selectedDevices);
                    }
                })
            })
        }

        self.getCarriers = function() {
            ProductService.getCarriersContentForTiktok({ clientId: self.clientId, clusterId: self.clusterId}).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    self.errorFetchingCarriers = false;
                    _.each(success.data, function (content) {
                        let carriers = {};
                        carriers.id = content.id;
                        carriers.name = content.name;
                        carriers.status = "";
                        carriers.isChecked = false;
                        carriers.parentName = content.parentName;
                        carriers.childData = content.childData;
                        carriers.type = content.type;
                        self.carriersList.push(carriers);
                    });
                    _.each(self.selectedTiktokDeviceTargeting, function (item) {
                        item.carriersList = angular.copy(self.carriersList);
                    })
                    processCarriersData();
                } else {
                    self.errorFetchingCarriers = true;
                }
            }, function (error) {console.log(error); });
        };

        let processCarriersData = function () {
            _.each(self.selectedTiktokDeviceTargeting, function (data) {
                _.each(data.carriers, function (item) {
                    _.each(data.carriersList, function (e) {
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubCarriers(e.childData,data.carriers);
                        }
                    })
                })
            })
        }
        let processSubCarriers = function(childData,selectedCarriers){
            _.each(selectedCarriers,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubCarriers(e.childData,selectedCarriers);
                    }
                })
            })
        }

        self.handleSelectCarriers = function (carriers, selectedTiktokDeviceTargeting) {
            if (!carriers.isChecked) {
                carriers.status = '';
                carriers.isChecked = false;
                let selIndex = selectedTiktokDeviceTargeting.carriers.indexOf(carriers);
                if (selIndex >= 0) {
                    selectedTiktokDeviceTargeting.carriers.splice(selIndex, 1);
                } else {
                    if (selectedTiktokDeviceTargeting.carriers && selectedTiktokDeviceTargeting.carriers.length > 0) {
                        if (_.find(selectedTiktokDeviceTargeting.carriersList, { id: carriers.id })) {
                            let index = _.findIndex(selectedTiktokDeviceTargeting.carriersList, { id: carriers.id });
                            selectedTiktokDeviceTargeting.carriers.splice(index, 1);
                        }
                    }
                }
            } else {
                carriers.status = 'selected';
                carriers.isChecked = true;
                selectedTiktokDeviceTargeting.carriers.push(carriers);
            }
        }

        self.removeCarriers = function (item, selectedCarriers, carriersList) {
            let selIndex = selectedCarriers.indexOf(item);
            if (selIndex >= 0) {
                selectedCarriers.splice(selIndex, 1);
                self.clearSelectedData(item,carriersList);
            }
        }

        self.getIsp = function() {
            ProductService.getIspContentForTiktok({ clientId: self.clientId, clusterId: self.clusterId, location_ids: '%5B%226252001%22%5D',scene: 'ISP'}).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    self.errorFetchingIsp = false;
                    _.each(success.data, function (content) {
                        let isp = {};
                        isp.id = content.id;
                        isp.name = content.name;
                        isp.status = "";
                        isp.isChecked = false;
                        isp.parentName = content.parentName;
                        isp.childData = content.childData;
                        isp.type = content.type;
                        self.ispList.push(isp);
                    });
                    _.each(self.selectedTiktokDeviceTargeting, function (item) {
                        item.ispList = angular.copy(self.ispList);
                    })
                    processIspData();
                } else {
                    self.errorFetchingIsp = true;
                }
            }, function (error) {console.log(error);});
        };

        let processIspData = function () {
            _.each(self.selectedTiktokDeviceTargeting, function (data) {
                _.each(data.isp, function (item) {
                    _.each(data.ispList, function (e) {
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubIsp(e.childData,data.isp);
                        }
                    })
                })
            })
        }
        let processSubIsp = function(childData,selectedIsp){
            _.each(selectedIsp,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubIsp(e.childData,selectedIsp);
                    }
                })
            })
        }

        self.handleSelectIsp = function (isp, selectedTiktokDeviceTargeting) {
            if (!isp.isChecked) {
                isp.status = '';
                isp.isChecked = false;
                let selIndex = selectedTiktokDeviceTargeting.isp.indexOf(isp);
                if (selIndex >= 0) {
                    selectedTiktokDeviceTargeting.isp.splice(selIndex, 1);
                } else {
                    if (selectedTiktokDeviceTargeting.isp && selectedTiktokDeviceTargeting.isp.length > 0) {
                        if (_.find(selectedTiktokDeviceTargeting.ispList, { id: isp.id })) {
                            let index = _.findIndex(selectedTiktokDeviceTargeting.ispList, { id: isp.id });
                            selectedTiktokDeviceTargeting.isp.splice(index, 1);
                        }
                    }
                }
            } else {
                isp.status = 'selected';
                isp.isChecked = true;
                selectedTiktokDeviceTargeting.isp.push(isp);
            }
        }

        self.removeIsp = function (item, selectedIsp, ispList) {
            let selIndex = selectedIsp.indexOf(item);
            if (selIndex >= 0) {
                selectedIsp.splice(selIndex, 1);
                self.clearSelectedData(item,ispList);
            }
        }

        self.getOperatingSystemVersions = function() {
            ProductService.getTiktokOsVersionContent({
                clientId: self.clientId,
                clusterId: self.clusterId,
                operatingSystem: self.selectedOperatingSystem
            }).then(function(success) {
                if (success && success.data && success.data.length > 0) {
                    self.errorFetchingOsVersions = false;
                    self.osVersionList = []; //Will set to empty array if there is already data acoording to the selected os version
                    _.each(success.data, function (content) {
                        let osVersion = {
                            id: content.id,
                            name: content.name,
                            version: content.version
                        };
                        self.osVersionList.push(osVersion);
                    });
                    _.each(self.selectedTiktokDeviceTargeting, function (item) {
                        item.osVersionList = angular.copy(self.osVersionList);
                    })
                } else {
                    self.errorFetchingOsVersions = true;
                }
            }, function (error) { })
        }

        self.setExclude = function(){
            _.each(self.selectedTiktokDeviceTargeting,function(item){
                if (item.excludeAdded) {
                    self.hideExclude = true;
                }
            })
        }

        self.initComponent = function () {
            if (self.selectedTiktokDeviceTargeting && !_.isEmpty(self.selectedTiktokDeviceTargeting)) {
                self.selectedTiktokDeviceTargeting= JSON.parse(self.selectedTiktokDeviceTargeting);
                if (self.showActions && self.showActionsForOsVersion) {
                    self.editMode = true;
                    self.enableViewMode = false;
                    self.showActions = false;
                    self.showActionsForOsVersion = false;
                    if (!_.isEmpty(self.selectedTiktokDeviceTargeting[0].operatingSystem)) {
                        self.selectedOperatingSystem = self.selectedTiktokDeviceTargeting[0].operatingSystem;
                    }
                    if (!_.isEmpty(self.selectedTiktokDeviceTargeting[0].operatingSystemVersion)) {
                        self.selectedOperatingSystemVersion = self.selectedTiktokDeviceTargeting[0].operatingSystemVersion.name;
                    }
                    self.getOperatingSystemVersions();
                    self.getCarriers();
                    self.getIsp();
                } else {
                    self.editMode = false;
                    self.enableViewMode = true;
                    if (!_.isEmpty(self.selectedTiktokDeviceTargeting[0].operatingSystem)) {
                        self.selectedOperatingSystem = self.selectedTiktokDeviceTargeting[0].operatingSystem;
                    }
                    if (!_.isEmpty(self.selectedTiktokDeviceTargeting[0].operatingSystemVersion)) {
                        self.selectedOperatingSystemVersion = self.selectedTiktokDeviceTargeting[0].operatingSystemVersion.name;
                    }
                }
            } else {
                self.selectedTiktokDeviceTargeting = [{
                    operatingSystem: '',
                    operatingSystemVersion: {},
                    devices: [],
                    carriers: [],
                    isp : [],
                    overLapEnabled:true,
                    excludeEnabled:true
                }];
                self.enableViewMode = false;
                self.showActions = false;
                self.showActionsForOsVersion = false;
                self.getCarriers();
                self.getIsp();
                if (!_.isEmpty(self.selectedTiktokDeviceTargeting[0].operatingSystem)) {
                    self.selectedOperatingSystem = self.selectedTiktokDeviceTargeting[0].operatingSystem;
                }
                if (!_.isEmpty(self.selectedTiktokDeviceTargeting[0].operatingSystemVersion)) {
                    self.selectedOperatingSystemVersion = self.selectedTiktokDeviceTargeting[0].operatingSystemVersion.name;
                }
            }
        };
        self.initComponent();
    }
});